export const AUTH_ERRORS = {
  USER_EXISTS: 'user.exist',
  USER_NOT_EXIST: 'user.notFound',
  TOKEN_INVALID: 'user.token.invalid'
};
export const PROFILE_ERRORS = {
  INVALID_ZIPCODE: 'profile.zipcode.regexp',
  INVALID_NAME: 'profile.name.regexp',
};
export const USER_STATUS = {
  PENDING: 'STATUS_PENDING',
  ACTIVE: 'STATUS_ACTIVE'
};

export const USER_ROLES = {
  MANAGER: 'TYPE_MANAGER',
  USER: 'TYPE_USER'
};
